export const Sizing = {
  wrapperWidth: '1440px',
  gutterWidth: '40px',
  headerHeight: '80px',
  mobileHeaderHeight: '60px',
  mobileWidth: '900px',

  numeric: {
    wrapperWidth: 1440,
    gutterWidth: 40,
    headerHeight: 80,
  },

  borderRadius: {
    buttons: '400px',
  },
};

export const Colors = {
  primary: '#E85E85',
  accent: '#003DA5',
  black: '#1B1B1B',
  darkerGrey: '#3a3a3a',
  darkGrey: '#454545',
  lightGrey: '#646464',
  lighterGrey: '#b2b2b2',
  white: '#E9EDF1',
  pureWhite: '#FFFFFF',

  red: 'oklch(58.6% 0.253 17.585)',
  lightRed: 'oklch(89.2% 0.058 10.001)',
  darkRed: 'oklch(27.1% 0.105 12.094)',

  green: 'oklch(59.6% 0.145 163.225)',
  lightGreen: 'oklch(90.5% 0.093 164.15)',
  dimmedLightGreen: 'oklch(95% 0.052 163.051)',
  darkGreen: 'oklch(26.2% 0.051 172.552)',

  yellow: 'oklch(66.6% 0.179 58.318)',
  lightYellow: 'oklch(92.4% 0.12 95.746)',
  darkYellow: 'oklch(27.9% 0.077 45.635)',

  blue: 'oklch(58.8% 0.158 241.966)',
  lightBlue: 'oklch(90.1% 0.058 230.902)',
  darkBlue: 'oklch(29.3% 0.066 243.157)',
};
